import React, {useState, useEffect} from 'react';
import { MasterDataGrid } from "@/components/";
import FollowupSubProjectPresenter from "../../../../../presenters/screens/followup-subproject.presenter";
import { IFollowupSubproject } from "@interfaces/screens/followup-subproject.interface";
import { Enums } from "@utils";
import BeneficiariesError from '../beneficiaries-error';

export interface IByActivityProps{    
    dataColumns: any;
    columns: any;
	status: any;
	screen: any;
    actData: any;
    tableAlert: string;
    saveTable(instance: any): void;
    initialValidate: boolean;
    currentYear: string;
}

const Activity: React.FC<IByActivityProps> = ({initialValidate, dataColumns, columns, status, screen, actData, tableAlert, currentYear, saveTable} : IByActivityProps) => {
    const [auxData, setAuxData] = useState(null);
    const [initialError, setInitialEror] = useState(null);

	const view: IFollowupSubproject = {
        state: {
			dataColumns
        },
    };

	const presenter = new FollowupSubProjectPresenter(view);

    useEffect(() => {
        if((tableAlert === `beneficiaries-by-activity` || !tableAlert || tableAlert === 'All') && actData && columns) {
			if(presenter.stepTourBen > 1){
                let dataTour = presenter.getTourData(4, Enums.FollowupDimensions.beneficiaries, currentYear)
                let asd = getAuxData(dataTour)
                setAuxData(asd)
            }else{
                let asd = getAuxData()
                setAuxData(asd)
            }
        }
    }, [actData?.data, tableAlert, columns, initialError, presenter.stepTourBen]); 

    useEffect(() => {
        if(initialValidate && actData?.data?.length) {
			let missingInfo = !presenter.checkInfoBeneficiaries(actData?.data)
            setInitialEror(missingInfo)
        }
    }, [actData?.data, initialValidate]); 

    const getAuxData = (tourData?: any) => {
		return (
            <>
                <BeneficiariesError 
                    followupLabels={presenter.followupLabels}
                    tableAlert={tableAlert}
                    calculatedReqFields={(instance: any) => presenter.checkReqFields(instance, status)} 
                    gridId={`beneficiaries-by-activity`} 
                />
                {(!tourData && !actData?.data?.length) && 
                    <div style={{width:"100%", textAlign:"center", color:"red", padding:"1rem"}}>
                        {presenter.followupLabels.get("errorPOPInfo")}
                    </div>
                }
                {(initialError) &&
                    <div style={{width:"100%", textAlign:"center"}}>
                        <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{presenter.followupLabels.get("completeFrameworkInformation")}</h6>
                    </div>
                }
                <MasterDataGrid 
                    id={`beneficiaries-by-activity`}
                    dataSource={tourData || actData?.data || []}
                    columns={columns?.subProject || []}
                    allowCode={actData?.data?.length ? screen : Enums.FollowupState.view}
                    gridTitle={actData.staticTitle}
                    gridHelpId={'tooltip-byactivity'}
                    gridHelpText={presenter.followupLabels.get("helpBeneficiariesByActivity")}
                    saveTable={saveTable}
                    gridProps={{
                        editing:{ mode:"batch", allowUpdating:true, allowAdding: false, allowDeleting: false},
                        rowAlternationEnabled:false,
                    }}
                />
            </>
        )
    }

    return (
		<div id={"BeneficiariesTourStep4"}> 
            {auxData && auxData}
        </div>
	)
}

export default Activity;